import { useEffect, useState } from 'react';

/** Returns true when the viewport is below the given breakpoint (default 768).
 *  Used to short-circuit heavy Three.js scenes on phones / small tablets. */
export default function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(() =>
        typeof window !== 'undefined' && window.innerWidth < breakpoint
    );
    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < breakpoint);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [breakpoint]);
    return isMobile;
}
